// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables(areaIds) {
  return {
    areaIds: areaIds
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_areasV5_geometry_byType(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "MapMultiPolygon",
    "MapPolygon"
  ]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"areasV5_geometry_byType":{"u":"response_areasV5_geometry_byType"}}};

let wrapResponseConverterMap = {
  response_areasV5_geometry_byType: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"areasV5_geometry_byType":{"u":"response_areasV5_geometry_byType"}}};

let responseConverterMap = {
  response_areasV5_geometry_byType: unwrap_response_areasV5_geometry_byType
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "areaIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "areaIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CoordinatesV5",
    "kind": "LinkedField",
    "name": "coordinates",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lat",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lon",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MapLinearRing",
    "kind": "LinkedField",
    "name": "exteriorRing",
    "plural": false,
    "selections": (v3/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MapLinearRing",
    "kind": "LinkedField",
    "name": "interiorRings",
    "plural": true,
    "selections": (v3/*: any*/),
    "storageKey": null
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "MapPolygon",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MapPolygon",
      "kind": "LinkedField",
      "name": "polygons",
      "plural": true,
      "selections": (v4/*: any*/),
      "storageKey": null
    }
  ],
  "type": "MapMultiPolygon",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationSettingsAreaMapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Area",
        "kind": "LinkedField",
        "name": "areasV5",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "geometry",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/)
                  ],
                  "type": null,
                  "abstractKey": null
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "byType"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationSettingsAreaMapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Area",
        "kind": "LinkedField",
        "name": "areasV5",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "geometry",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isSearchMapGeometry"
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6f0d75ce32fcb7e0051d7ce4797e1888",
    "id": null,
    "metadata": {},
    "name": "NotificationSettingsAreaMapQuery",
    "operationKind": "query",
    "text": "query NotificationSettingsAreaMapQuery(\n  $areaIds: [ID!]!\n) {\n  areasV5(ids: $areaIds) {\n    geometry {\n      __typename\n      __isSearchMapGeometry: __typename\n      ... on MapPolygon {\n        exteriorRing {\n          coordinates {\n            lat\n            lon\n          }\n        }\n        interiorRings {\n          coordinates {\n            lat\n            lon\n          }\n        }\n      }\n      ... on MapMultiPolygon {\n        polygons {\n          exteriorRing {\n            coordinates {\n              lat\n              lon\n            }\n          }\n          interiorRings {\n            coordinates {\n              lat\n              lon\n            }\n          }\n        }\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_areasV5_geometry_byType = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_areasV5_geometry_byType = unwrap_response_areasV5_geometry_byType;
exports.wrap_response_areasV5_geometry_byType = wrap_response_areasV5_geometry_byType;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
